import React from 'react';
import { View, ScrollView } from 'react-native';
import { BidListDetail, BidListText, Subtitle, Value } from './elements';
import styled from 'styled-components/native';
import { dollars } from 'app/src/utils/stringHelpers';
import colors from 'app/src/styles/colors';

const Bid = styled(Value)`
  ${props => props.backgroundColor && !props.reversed ? `
    background-color: ${props.backgroundColor};
    color: ${props.foregroundColor};
  ` :
  `background-color: ${props.reversed ? '#ffa59e' : props.rowColor}`
  }

  border-bottom-width: 1px;
  padding: 2px;
`;

const BidHistory = ({ bids, clerk }) => {
  if(!clerk) {
    bids = [...bids].reverse();
  }
  return (
    <ScrollView style={{maxHeight: clerk ? '23vh' : '32.25vh'}}>
      <Subtitle>BID HISTORY</Subtitle>
      {!bids?.length && (
        <Subtitle style={{fontSize: '20px', fontWeight: 900}}>
          No Current Bids
        </Subtitle>
      )}
      {bids?.map((bid, index) => {
        let reversed = bid.note && bid.note.match(/(Reversed)*/);
        return(
          <Bid
            key={bid.id}
            {...bid}
            rowColor={ index % 2 === 0 ? colors.biddingTableRow : '#fff'}
            reversed={reversed}
          >
            <BidListDetail>
              <BidListText color={bid.foregroundColor} reversed={reversed}>
                {dollars(bid.price)}
              </BidListText>
            </BidListDetail>
            <BidListDetail>
              <BidListText color={bid.foregroundColor} reversed={reversed}>
                {bid.paddleService?.code || 'Floor'}
              </BidListText>
            </BidListDetail>
            {bid.paddleNumber ?
              <BidListDetail>
                <BidListText color={bid.foregroundColor} reversed={reversed}>
                  { bid.paddleNumber}
                </BidListText>
              </BidListDetail> :
              null
            }
            {bid.note ?
              <BidListDetail>
                <BidListText color={bid.foregroundColor} reversed={reversed}>
                  {bid.note}
                </BidListText>
              </BidListDetail> :
              null
            }
            {bid.buyer ?
              <BidListDetail>
                <BidListText color={bid.foregroundColor} reversed={reversed}>
                  {
                    `${bid.buyer.city || ''}` +
                    `${bid.buyer.city && bid.buyer.state ? ', ' : ''}` +
                    `${bid.buyer.state || ''}`
                  }
                </BidListText>
              </BidListDetail> :
              null
            }
          </Bid>
        )}
      )}
    </ScrollView>
  )
}

export default BidHistory;